import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils.ts";

export const cannotRenewReasonSchema = z.enum(["has_upcoming", "has_careplan_until_term", "deceased"]);
export type CannotRenewReason = z.infer<typeof cannotRenewReasonSchema>;

export const renewTypeSchema = z.enum([
  "create_patient",
  "renew_t12",
  "dg_start_insulin",
  "create_upcoming_t12",
  "create_upcoming_dg",
  "renew_gestational",
  "restart_monitoring",
]);
export type RenewType = z.infer<typeof renewTypeSchema>;

export const patientRenewalInfoSchema = z.discriminatedUnion("can_renew", [
  cz.camelCaseObject({
    can_renew: z.literal(true),
    renewal_type: renewTypeSchema,
    cannot_renew_reason: cz.optional(z.never()),
    can_interrupt_care_plan: cz.optional(z.boolean()),
  }),
  cz.camelCaseObject({
    can_renew: z.literal(false),
    renewal_type: cz.optional(z.never()),
    cannot_renew_reason: cannotRenewReasonSchema,
    can_interrupt_care_plan: cz.optional(z.boolean()),
  }),
]);

export type PatientRenewalInfo = z.infer<typeof patientRenewalInfoSchema>;

export const getRenewTypeTranslation = (renewalSuggestion: RenewType): string => {
  switch (renewalSuggestion) {
    case "create_upcoming_t12":
    case "create_upcoming_dg":
    case "renew_t12":
    case "renew_gestational":
      return "diabetesForms.renew";
    case "dg_start_insulin":
      return "diabetesForms.addInsulin";
    case "restart_monitoring":
      return "diabetesForms.restartMonitoring";
    case "create_patient":
      return "diabetesForms.createPatient";
  }
};

export const getCannotRenewTranslation = (cannotRenewReason: CannotRenewReason): string => {
  switch (cannotRenewReason) {
    case "has_upcoming":
      return "diabetesForms.renewed";
    case "has_careplan_until_term":
      return "diabetesForms.hasUntilTerm";
    case "deceased":
      return "diabetesForms.cannotRenewDeceased";
  }
};

export const getCannotRenewTooltipTranslation = (cannotRenewReason: CannotRenewReason): string | undefined => {
  switch (cannotRenewReason) {
    case "has_upcoming":
    case "has_careplan_until_term":
      return undefined;
    case "deceased":
      return "diabetesForms.cannotRenewDeceasedTooltip";
  }
};
